/* Odanas collection filters (2026-10-23)
 * - "Show more / Show less" for long plain filter lists   ([data-odf-showmore] container)
 * - Size / Color multi-select dropdowns                    ([data-odf-dropdown] wrapper)
 *
 * Plain ES2018, no dependencies. Event handling is delegated on document (installed once), and
 * state is re-applied after every theme AJAX refresh (the theme replaces innerHTML of [data-ajax-container])
 * via a MutationObserver, so main.js needs no changes. init() is idempotent.
 */
(function () {
  'use strict';

  if (window.__odanasFilters) {
    window.__odanasFilters.init();
    return;
  }

  var STORAGE_KEY = 'odf:expanded';
  var DROPDOWN = '[data-odf-dropdown]';
  var SHOWMORE = '[data-odf-showmore]';

  var state = {
    openKey: null, // param_name of the dropdown that is open
    openScrollTop: 0, // scrollTop of its panel
    lastFocusId: null, // id of the checkbox focused inside the open panel
    filtersScroll: 0, // scrollTop of the (mobile) .filters drawer when a checkbox changed
    expanded: loadExpanded() // { param_name: true }
  };

  /* ---------- storage ---------- */
  function loadExpanded() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveExpanded() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state.expanded));
    } catch (e) { /* storage unavailable: in-memory state is enough */ }
  }

  /* ---------- helpers ---------- */
  function findDropdown(key) {
    if (!key) return null;
    var all = document.querySelectorAll(DROPDOWN);
    for (var i = 0; i < all.length; i += 1) {
      if (all[i].getAttribute('data-odf-dropdown') === key) return all[i];
    }
    return null;
  }

  function parts(dd) {
    return {
      trigger: dd.querySelector('.odf-dropdown__trigger'),
      panel: dd.querySelector('.odf-dropdown__panel'),
      value: dd.querySelector('.odf-dropdown__value'),
      badge: dd.querySelector('.odf-dropdown__badge')
    };
  }

  /* ---------- Show more ---------- */
  function applyShowMore(container, expanded) {
    var btn = container.querySelector('.odf-showmore__btn');
    container.classList.toggle('odf-showmore--collapsed', !expanded);
    if (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded
        ? btn.getAttribute('data-odf-less-label') || 'Show less'
        : btn.getAttribute('data-odf-more-label') || 'Show more';
    }
  }

  function initShowMore() {
    document.querySelectorAll(SHOWMORE).forEach(function (container) {
      var key = container.getAttribute('data-odf-showmore');
      applyShowMore(container, !!state.expanded[key]);
    });
  }

  function toggleShowMore(btn) {
    var container = btn.closest(SHOWMORE);
    if (!container) return;
    var key = container.getAttribute('data-odf-showmore');
    var expand = container.classList.contains('odf-showmore--collapsed');
    if (expand) {
      state.expanded[key] = true;
    } else {
      delete state.expanded[key];
    }
    saveExpanded();
    applyShowMore(container, expand);
  }

  /* ---------- Dropdowns ---------- */
  function updateLabel(dd) {
    var p = parts(dd);
    if (!p.value) return;
    var labels = [];
    dd.querySelectorAll('.filter-group__checkbox:checked').forEach(function (cb) {
      var lbl = cb.closest('label');
      var text = lbl && lbl.querySelector('.odf-item__label');
      if (text) labels.push(text.textContent.trim());
    });
    var placeholder = dd.getAttribute('data-odf-placeholder') || '';
    if (labels.length) {
      p.value.textContent = labels.join(', ');
      p.value.title = labels.join(', ');
      p.value.classList.remove('odf-dropdown__value--placeholder');
    } else {
      p.value.textContent = placeholder;
      p.value.removeAttribute('title');
      p.value.classList.add('odf-dropdown__value--placeholder');
    }
    if (p.badge) {
      p.badge.textContent = String(labels.length);
      p.badge.hidden = labels.length <= 2;
    }
    dd.querySelectorAll('.odf-dropdown__item').forEach(function (item) {
      var cb = item.querySelector('.filter-group__checkbox');
      item.classList.toggle('filter-group__item--active', !!(cb && cb.checked));
    });
  }

  function openDropdown(dd, opts) {
    var p = parts(dd);
    if (!p.trigger || !p.panel) return;
    var key = dd.getAttribute('data-odf-dropdown');
    if (state.openKey && state.openKey !== key) closeDropdown(findDropdown(state.openKey), false);
    p.panel.hidden = false;
    p.trigger.setAttribute('aria-expanded', 'true');
    state.openKey = key;
    if (opts && typeof opts.scrollTop === 'number') p.panel.scrollTop = opts.scrollTop;
    if (opts && opts.focusFirst) {
      var first = p.panel.querySelector('.filter-group__checkbox:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function closeDropdown(dd, returnFocus) {
    if (!dd) {
      state.openKey = null;
      return;
    }
    var p = parts(dd);
    if (p.panel) p.panel.hidden = true;
    if (p.trigger) {
      p.trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) p.trigger.focus();
    }
    if (state.openKey === dd.getAttribute('data-odf-dropdown')) {
      state.openKey = null;
      state.openScrollTop = 0;
      state.lastFocusId = null;
    }
  }

  function closeAll(returnFocus) {
    var key = state.openKey;
    document.querySelectorAll(DROPDOWN).forEach(function (dd) {
      var p = parts(dd);
      if (p.panel && !p.panel.hidden) closeDropdown(dd, returnFocus && dd.getAttribute('data-odf-dropdown') === key);
    });
    state.openKey = null;
  }

  // Re-apply state after the theme replaced the filter markup.
  function initDropdowns() {
    document.querySelectorAll(DROPDOWN).forEach(updateLabel);
    if (!state.openKey) return;
    var dd = findDropdown(state.openKey);
    if (!dd) {
      state.openKey = null;
      return;
    }
    var panelEl = parts(dd).panel;
    if (panelEl && !panelEl.hidden) return; // already open, nothing to re-apply
    var hadFocusId = state.lastFocusId;
    openDropdown(dd, { scrollTop: state.openScrollTop });
    // mobile drawer: the theme restored its scroll position while the panel was still closed; put it back
    var drawer = dd.closest('.filters');
    if (drawer && drawer.scrollHeight > drawer.clientHeight && state.filtersScroll > 0) {
      drawer.scrollTop = state.filtersScroll;
    }
    if (hadFocusId) {
      var el = document.getElementById(hadFocusId);
      if (el && dd.contains(el) && !el.disabled) el.focus({ preventScroll: true });
    }
  }

  function init() {
    initShowMore();
    initDropdowns();
  }

  /* ---------- delegated events (installed once) ---------- */
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!(target instanceof Element)) return;

    var more = target.closest('.odf-showmore__btn');
    if (more) {
      evt.preventDefault();
      toggleShowMore(more);
      return;
    }

    var trigger = target.closest('.odf-dropdown__trigger');
    if (trigger) {
      evt.preventDefault();
      var dd = trigger.closest(DROPDOWN);
      if (!dd) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeDropdown(dd, false);
      } else {
        openDropdown(dd, { scrollTop: 0 });
      }
      return;
    }

    // click outside any open dropdown closes it
    if (state.openKey && !target.closest(DROPDOWN)) closeAll(false);
  });

  document.addEventListener('keydown', function (evt) {
    var target = evt.target;
    if (!(target instanceof Element)) return;
    var dd = target.closest(DROPDOWN);

    if (evt.key === 'Escape' || evt.key === 'Esc') {
      if (dd && !parts(dd).panel.hidden) {
        evt.preventDefault();
        evt.stopPropagation();
        closeDropdown(dd, true);
      } else if (state.openKey) {
        closeAll(false);
      }
      return;
    }

    if (dd && target.closest('.odf-dropdown__trigger') && (evt.key === 'ArrowDown' || evt.key === 'ArrowUp')) {
      evt.preventDefault();
      if (parts(dd).panel.hidden) openDropdown(dd, { scrollTop: 0, focusFirst: true });
      else {
        var first = parts(dd).panel.querySelector('.filter-group__checkbox:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }

    // simple arrow navigation between enabled checkboxes inside an open panel
    if (dd && target.matches('.filter-group__checkbox') && (evt.key === 'ArrowDown' || evt.key === 'ArrowUp')) {
      evt.preventDefault();
      var boxes = Array.prototype.slice.call(
        parts(dd).panel.querySelectorAll('.filter-group__checkbox:not(:disabled)')
      );
      var idx = boxes.indexOf(target);
      var next = boxes[idx + (evt.key === 'ArrowDown' ? 1 : -1)];
      if (next) next.focus({ preventScroll: false });
    }
  }, true);

  // Tabbing out of the panel closes it
  document.addEventListener('focusout', function (evt) {
    var dd = evt.target instanceof Element ? evt.target.closest(DROPDOWN) : null;
    if (!dd || parts(dd).panel.hidden) return;
    var next = evt.relatedTarget;
    if (next instanceof Element && !dd.contains(next)) closeDropdown(dd, false);
  });

  // Track focus + panel scroll so we can restore them after the AJAX refresh
  document.addEventListener('focusin', function (evt) {
    var t = evt.target;
    if (t instanceof Element && t.closest('.odf-dropdown__panel') && t.id) state.lastFocusId = t.id;
  });

  document.addEventListener('scroll', function (evt) {
    var t = evt.target;
    if (t instanceof Element && t.classList.contains('odf-dropdown__panel')) state.openScrollTop = t.scrollTop;
  }, true);

  // Update trigger label / badge immediately when a checkbox changes (the AJAX refresh follows ~700ms later)
  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!(t instanceof Element)) return;
    var dd = t.closest(DROPDOWN);
    if (dd) {
      state.openKey = dd.getAttribute('data-odf-dropdown');
      if (t.id) state.lastFocusId = t.id;
      var drawer = dd.closest('.filters');
      state.filtersScroll = drawer ? drawer.scrollTop : 0;
      updateLabel(dd);
    }
  });

  /* ---------- re-apply after AJAX content swaps ---------- */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // microtask: runs before the next paint, so the panel never flashes closed
    Promise.resolve().then(function () {
      scheduled = false;
      init();
    });
  }

  function isRelevant(node) {
    if (!(node instanceof Element)) return false;
    if (node.matches(DROPDOWN + ',' + SHOWMORE + ',.filters,.filters__inner')) return true;
    return !!node.querySelector(DROPDOWN + ',' + SHOWMORE);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        if (isRelevant(added[j])) {
          schedule();
          return;
        }
      }
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    init();
  }

  window.__odanasFilters = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
